<template>
  <div class="payment-modal-wrapper">
    <Payment />
    <div class="payment-modal__buttons">
      <button class="button button--red" @click="cancelOrder">Cancel</button>
      <button
        class="button button--green"
        :class="{'button--disabled': disabled}"
        :disabled="disabled || paying"
        @click="payOrder"
      >
        Pay
      </button>
    </div>
  </div>
</template>

<script>
import Payment from '../NewOrder/Payment'
import StatusModal from '../NewOrder/Status'
import {mapState} from 'vuex'

export default {
  name: 'PaymentModal',
  components: {Payment},
  props: {
    order: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      paying: false
    }
  },
  computed: {
    ...mapState({
      card: s => s.card.activeCard
    }),
    disabled() {
      return !this.card || !this.card.active
    }
  },
  methods: {
    async payOrder() {
      if (!this.card || !this.card.active || this.paying) return
      // Lock while the request runs: two taps used to create two Stripe
      // authorization holds on the same order.
      this.paying = true
      try {
        const pmInfo = await this.$store.dispatch('payment/pay', {id: this.order.id, pmID: this.card.paymentID})
        const result = pmInfo.data.result
        this.openStatusScreen(result)
        this.reset()
      } catch (e) {
        // Message surfaced by the layout's error watcher; release the lock.
      } finally {
        this.paying = false
      }
    },
    cancelOrder() {
      this.$modal.hide('PaymentModal')
    },
    openStatusScreen(result) {
      const mobile = document.documentElement.clientWidth <= 480
      let modalHeight = mobile ? {height: '100%'} : {height: 600}
      this.$modal.display(
        StatusModal,
        {
          result,
          onlyPay: true
        },
        {
          name: 'StatusModal',
          transition: 'none',
          ...modalHeight,
          classes: 'modal modal-order-status'
        }
      )
    },
    reset() {
      this.$modal.hide('PaymentModal')
      this.$store.commit('card/reset')
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'style';
</style>
